import { memo } from 'react'

export default memo(({ children, condition }) =>
  condition ? children[0] : children[1],
)



// WEBPACK FOOTER //
// ./src/Containers/Sidebar/components/IfElse.js